import React from 'react';

const MentionText = ({ children, className = '' }) => {
  if (typeof children !== 'string') {
    return <span className={className}>{children}</span>;
  }

  // Regex to find @username mentions
  const mentionRegex = /@([a-zA-Z0-9_]+)/g;
  
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = mentionRegex.exec(children)) !== null) {
    // Add text before the mention
    if (match.index > lastIndex) {
      parts.push(children.substring(lastIndex, match.index));
    }
    
    // Add the highlighted mention
    parts.push(
      <span 
        key={match.index}
        className="bg-blue-100 text-blue-800 px-1 py-0.5 rounded text-sm font-medium"
        title={`User: ${match[1]}`}
      >
        @{match[1]}
      </span>
    );
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text after the last mention
  if (lastIndex < children.length) {
    parts.push(children.substring(lastIndex));
  }
  
  return <span className={className}>{parts.length > 0 ? parts : children}</span>;
};

export default MentionText;